module.exports = __webpack_public_path__ + "static/honey-47d8181c9b6210f51f1e1c72c21617e2.jpg";